// extracted by mini-css-extract-plugin
export var menuBtn = "navigation-module--menuBtn--3ql0j";
export var menu = "navigation-module--menu--jywjH";
export var show = "navigation-module--show--kWfKk";
export var menuTitle = "navigation-module--menuTitle--LMpn3";
export var menuScroll = "navigation-module--menuScroll--1F4bw";